// src/admin/adminTheme.js
import { createTheme } from "@mui/material/styles";

const adminTheme = createTheme({
  palette: {
    mode: "light",

    /* 🎨 Brand */
    primary: {
      main: "#e63311",
    },

    background: {
      default: "#f3f4f6",
      paper: "#ffffff",
    },

    /* 🖤 GLOBAL TEXT COLORS */
    text: {
      primary: "#000000",     // main text → BLACK
      secondary: "#000000",   // secondary text → BLACK
      disabled: "#555555",
    },
  },

  typography: {
    fontFamily: "Sora, system-ui, -apple-system, sans-serif",

    /* Make all variants black by default */
    allVariants: {
      color: "#000000",
    },

    h1: { fontWeight: 800 },
    h2: { fontWeight: 800 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
  },

  components: {
    /* 🧾 DataGrid */
    MuiDataGrid: {
      styleOverrides: {
        root: {
          color: "#000000",
        },
        columnHeaders: {
          color: "#000000",
          fontWeight: 700,
        },
        cell: {
          color: "#000000",
        },
      },
    },

    /* 📝 Inputs */
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: "#000000",
        },
      },
    },

    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "#000000",
        },
      },
    },

    /* 🔘 Buttons */
    MuiButton: {
      styleOverrides: {
        root: {
          color: "#000000",
          fontWeight: 700,
        },
      },
    },

    /* 🧩 Chips */
    MuiChip: {
      styleOverrides: {
        label: {
          color: "#000000",
          fontWeight: 600,
        },
      },
    },
  },
});

export default adminTheme;